import { Box, SvgIcon, Typography } from '@material-ui/core';
import React, { memo } from 'react';
import { OrgAssociateStatus as OrgAssociateStatusType } from 'src/types';
import StatusIcon from './StatusIcon';
import { useStylesOrgAssociateStatus } from './styles';

type Props = {
  status: OrgAssociateStatusType;
};

const OrgAssociateStatus: React.FC<Props> = ({ status }) => {
  const classes = useStylesOrgAssociateStatus({ status });

  return (
    <Box display="flex" alignItems="center">
      <SvgIcon
        name={`status-icon-${status}`}
        className={classes.icon}
        data-testid="status-icon"
      >
        <StatusIcon status={status} />
      </SvgIcon>
      <Typography
        variant="subtitle2"
        className={classes.title}
        data-testid="status-title"
      >
        {status.toLocaleLowerCase()}
      </Typography>
    </Box>
  );
};

export default memo(OrgAssociateStatus);
